module.exports = __webpack_public_path__ + "assets/retina_HarmonicMeanDetailed.ed88070a8df5231e66a782726f9b1166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_HarmonicMeanDetailed.png
// module id = 672
// module chunks = 0